import React from 'react'
import clsx from 'classnames'
import type { PopulatedAppointment } from 'src/hooks/usePopulatedAppointments'
import { VisitCard } from './VisitCard'
import styles from './Visit.module.scss'

type CurrentVisitProps = {
  visit: PopulatedAppointment,
  className?: string,
  onClickChange: (e: React.MouseEvent) => void,
  onClickCall: (e: React.MouseEvent) => void,
  onClickCancel: (e: React.MouseEvent) => void,
}

/** An upcoming visit: change, call the salon or cancel */
export const CurrentVisit: React.FC<CurrentVisitProps> = React.memo((props) => {
  const { visit, className, onClickChange, onClickCall, onClickCancel } = props
  return (
    <VisitCard
      className={clsx([styles.container, styles.future, className])}
      visit={visit}
      icon={<i className={styles.dateInfoIcon} />}
      actions={[
        { name: 'change', title: 'Изменить', onClick: onClickChange },
        { name: 'call', title: 'Позвонить', onClick: onClickCall },
        { name: 'cancel', title: 'Отменить запись', onClick: onClickCancel },
      ]}
    />
  )
})
CurrentVisit.displayName = 'CurrentVisit'
